import { SaveAll } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SaveMultipleIcon = createLucideIcon(SaveAll);
